

const initBarStats = () => {

    const onBarStatIntersection = (entries) => {
        for (const entry of entries) {
            if( entry.target.dataset.triggered == false) {
                if (entry.isIntersecting) {



                    let numDisplay = entry.target.dataset.numDisplay,
                        barTarget = entry.target.dataset.barTarget,
                        barFiller = entry.target.querySelector('.progress-bar__fill')

                        setTimeout( () =>  {
                            barFiller.style.width = barTarget + '%'
                            barFiller.style.transition = '1s'
                        },100)

                    if(numDisplay == true) {
                        let stat = entry.target.querySelector('.progress-bar__stat'),
                            statStart = 0,
                            statTarget = stat.dataset.numTarget,
                            duration = 1000

                            const text = entry.target.querySelector('.progress-bar__num > span');
                            const step = (timestamp) => {
                                if (!statStart) statStart = timestamp;
                                const progress = timestamp - statStart;
                                const percentage = Math.min(progress / duration, 1);
                                const value = Math.floor(percentage * statTarget);
                                text.innerHTML = value.toLocaleString();
                                if (progress < duration) {
                                    window.requestAnimationFrame(step);
                                }
                            };
                            window.requestAnimationFrame(step);
                    }

                    entry.target.dataset.triggered = true
                }
            }
        }
    };

    const bars = document.querySelectorAll('.progress-bar')
    if (bars.length) {
        const barStatObserver = new IntersectionObserver(onBarStatIntersection);
        for (const bar of bars) {
            barStatObserver.observe(bar);
        }
    }
}
